import type { ILineStatusItem, LineStatusValue } from "@/lib/backend/manufacturing2.generated.types";

export type LineStatusDisplay = {
    stale: boolean;
    status: LineStatusValue;
};

/**
 * Persisted live status is authoritative when available. When it is absent,
 * fall back to the ongoing downtime inference carried by the unified endpoint.
 */
export function getLineStatusDisplay(status: ILineStatusItem): LineStatusDisplay {
    if (status.live.hasStatusRow) {
        return { stale: status.live.stale, status: status.live.status };
    }

    const downtime = status.inferredOperation?.downtime;
    if (downtime !== undefined && downtime.severity > 0) {
        return {
            stale: false,
            status: downtime.severity > 1 ? "stopped" : "idle",
        };
    }

    return { stale: status.live.stale, status: status.live.status };
}
